import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { HttpClient } from '@angular/common/http';

import { AuthGuardService } from '../../../services/auth-guard.service';

@Component({
  selector: 'msgs-dialog',
  templateUrl: './msgs.dialog.html'
})
export class MessagesDialogComponentS implements OnInit {

  msgs;
  title;
  options;

  constructor(
    public _authService: AuthGuardService,
    public dialogRef: MatDialogRef<MessagesDialogComponentS>,
    private _http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.options = data.options;
    this.msgs = data.msgs;
    this.title = "Hai <b>" + this.msgs.length + "</b> messagg" + (this.msgs.length > 1 ? "i" : "io");
  }

    ngOnInit() {
    }

    close (a) {
      this.dialogRef.close(a);
    }

}